import { useTranslation } from 'react-i18next';
import { type PromptMode, promptModes } from '../constants';

type ButtonLabelKey = 'Search' | 'REGENERATE';

export const useButtonLabel = (mode: PromptMode): ButtonLabelKey => {
  const { t } = useTranslation();

  if (mode === promptModes.DEFAULT_MODE) {
    return t('Search') as ButtonLabelKey;
  }

  return t('REGENERATE') as ButtonLabelKey;
};
